import { render, staticRenderFns } from "./EditQuoteRate.vue?vue&type=template&id=fc0162b2"
import script from "./EditQuoteRate.vue?vue&type=script&lang=js"
export * from "./EditQuoteRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports